<template>
    <div class="chart-analytics-time-practice">
        <div class="chart-analytics-time-practice__header">
            <span class="chart-analytics-time-practice__header-icon"></span>
            <div class="chart-analytics-time-practice__heading">
                <span class="chart-analytics-time-practice__heading-period">{{ textHeadingPeriod }}</span>
                <span class="chart-analytics-time-practice__heading-text">Pratik Süresi Gelişimi</span>
            </div>
        </div>
        <div class="chart-analytics-time-practice__wr-chart">
            <div
                v-if="showPreloader"
                class="chart-analytics-time-practice__preloader"></div>
            <canvas
                v-if="!showPreloader"
                id="chart-analytics-time-practice__chart"></canvas>
        </div>
        <div
            v-if="!showPreloader"
            class="chart-analytics-time-practice__legend">
            <span class="chart-analytics-time-practice__legend-icon"></span>
            <span class="chart-analytics-time-practice__legend-text">pratik süresi</span>
        </div>
    </div>
</template>
<script>
    import Chart from 'chart.js/auto';
    let chartInstance = null;

    export default {
        data(){
            return {
                showPreloader: true
            };
        },

        computed: {
            filteredChartTimePracticeData(){
                if(this.showPreloader){
                    return null;
                }
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.timePracticeMode.type;
                return this.$store.state.response.analyticsPractice.chartTimePracticeData[selectedFiltertagType];
            },

            textHeadingPeriod(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.timePracticeMode.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'HAFTALIK';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'AYLIK';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'YILLIK';
                }
            }
        },

        watch: {
            filteredChartTimePracticeData: {
                handler(nv, ov){
                    if(!this.filteredChartTimePracticeData){
                        return;
                    }
                    if(!chartInstance){
                        return;
                    }
                    this.$nextTick(() => {
                        chartInstance.destroy();
                        this.createChart();
                    });
                },
                deep: true
            }
        },

        methods: {
            determineStepSize(data){
                let stepSize = 10;
                data.forEach(i => {
                    if(i > 60){
                        stepSize = 60;
                    }
                });
                return stepSize;
            },

            createChart(){
                Chart.defaults.font.family = 'Overpass';
                chartInstance = new Chart(document.querySelector('#chart-analytics-time-practice__chart'), {
                    type: 'line',
                    data: {
                        labels: this.filteredChartTimePracticeData.labels,
                        datasets: [{
                            data: this.filteredChartTimePracticeData.data,
                            borderWidth: 2,
                            borderColor: '#2779ED',
                            pointRadius: 2.5,
                            pointBackgroundColor: '#2779ED',
                            cubicInterpolationMode: 'monotone',
                            fill: true,
                            backgroundColor: (context) => {
                                if(!context.chart.chartArea){return;}
                                let chartArea = context.chart.chartArea;
                                let ctx = context.chart.ctx;
                                let gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                                gradient.addColorStop(0, 'rgba(39, 121, 237, 0.35)');
                                gradient.addColorStop(1, 'rgba(39, 121, 237, 0.05)');
                                return gradient;
                            }
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                border: {
                                    color: '#A0B8EB'
                                },
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    font: {
                                        size: 11,
                                    }
                                }
                            },
                            y: {
                                border: {
                                    display: false,
                                },
                                grid: {
                                    color: '#CCCCCC',
                                    lineWidth: 1,
                                },
                                ticks: {
                                    font: {
                                        size: 11,
                                    },
                                    callback: (value) => {
                                        if(value <= 59){
                                            return `${value} dk.`;
                                        }

                                        let h = Math.floor(value / 60);
                                        let m = value - (h * 60);

                                        return m == 0
                                               ? `${h} sa.`
                                               : [`${h} sa.`, `${m} dk.`]
                                    },
                                    stepSize: this.determineStepSize(this.filteredChartTimePracticeData.data),
                                },
                                beginAtZero: true,
                            }
                        },
                        plugins: {
                            legend: {
                                display: false,
                            },
                            tooltip: {
                                callbacks: {
                                    label: (context) => {
                                        let value = context.raw;
                                        if(value <= 59){
                                            return `${value} dk.`;
                                        }

                                        let h = Math.floor(value / 60);
                                        let m = value - (h * 60);

                                        return m == 0
                                               ? `${h} sa.`
                                               : `${h} sa. ${m} dk.`
                                    }
                                }
                            }
                        }
                    }
                });
            }
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsChartTimePractice)
                .then(response => response.json())
                .then(chartTimePracticeData => {
                    this.$store.commit('setResponse', {
                        'categoryLabel': 'analyticsPractice',
                        'dataLabel': 'chartTimePracticeData',
                        data: chartTimePracticeData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    })
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPracticeChartTimePractice, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(chartTimePracticeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'chartTimePracticeData',
                        data: chartTimePracticeData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    });
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/chart-analytics-time-practice.css"></style>